import { useEffect } from 'react'
import { cacheManager } from './cache-manager'
import { queryDeduplicationManager } from './query-deduplication-manager'
import { supabase } from '~/supabase-client'

const CACHE_INVALIDATE_THRESHOLD_MS = 2 * 60 * 1000   // 2 min — min meaningful TTL
const AUTH_REFRESH_THRESHOLD_MS = 30 * 60 * 1000       // 30 min — safety net before JWT expiry

export const usePageVisibilityRefresh = () => {
  useEffect(() => {
    let hiddenAt = null

    const handleVisibilityChange = () => {
      if (document.hidden) {
        hiddenAt = Date.now()
      } else {
        const hiddenMs = hiddenAt !== null ? Date.now() - hiddenAt : 0
        hiddenAt = null

        // Always: clear stuck in-flight promises (safe regardless of idle time)
        queryDeduplicationManager.clearAll()

        if (hiddenMs > CACHE_INVALIDATE_THRESHOLD_MS) {
          cacheManager.invalidateAll()
        }

        if (hiddenMs > AUTH_REFRESH_THRESHOLD_MS) {
          supabase.auth.refreshSession()
        }
      }
    }

    document.addEventListener('visibilitychange', handleVisibilityChange)
    return () => document.removeEventListener('visibilitychange', handleVisibilityChange)
  }, [])
}
